// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7DdgG","largestCol":"styles_largestCol__2_Pm1","smallestCol":"styles_smallestCol__ZS5pA"};